import { connect } from 'react-redux'

import { setLanguage } from 'src/modules/App/actions'

import LanguageWrapper from './LanguageWrapper'

const mapDispatchToProps = {
  setLanguage,
}

const mapStateToProps = state => {
  return {
    language: state.appReducer.language,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LanguageWrapper)
